module.exports = __webpack_public_path__ + "static/media/mercado_cover.25dda562.jpg";